import React from 'react';
import { linearScale } from './scale';

const WIDTH = 200;
const HEIGHT = 44;
const PAD = 6;

/**
 * Runs of consecutive non-null points, so a missing value breaks the line
 * instead of being drawn as zero.
 */
function runs(points) {
  const out = [];
  let current = [];
  points.forEach((p) => {
    if (p == null) {
      if (current.length) out.push(current);
      current = [];
    } else current.push(p);
  });
  if (current.length) out.push(current);
  return out;
}

/**
 * A small line of `values` (null for a gap) on a fixed 0..max scale, with a
 * dot on the latest value. No axis labels: the caller prints the first and
 * latest values as text beside it, and `label` describes it to screen readers.
 */
const Sparkline = ({ values, max, label, tone = '' }) => {
  const x = linearScale([0, Math.max(values.length - 1, 0)], [PAD, WIDTH - PAD]);
  const y = linearScale([0, max], [HEIGHT - PAD, PAD]);
  const points = values.map((v, i) => (v == null ? null : [x(i), y(v)]));
  const last = [...points].reverse().find((p) => p != null);
  const toneClass = tone ? ` td-act-spark--${tone}` : '';

  return (
    <svg className={`td-act-spark${toneClass}`} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} preserveAspectRatio="none" role="img" aria-label={label}>
      <line className="td-act-spark__base" x1="0" y1={HEIGHT - PAD} x2={WIDTH} y2={HEIGHT - PAD} />
      {runs(points).filter((r) => r.length > 1).map((r) => (
        <polyline key={r[0].join(',')} className="td-act-spark__line" points={r.map((p) => p.join(',')).join(' ')} />
      ))}
      {last ? <circle className="td-act-spark__dot" cx={last[0]} cy={last[1]} r="3" /> : null}
    </svg>
  );
};

export default Sparkline;
